import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ISearchMakerProductsRequest) {
    (function(ISortingHint) {
        ISortingHint.build = function(partial) {
            return _object_spread({
                ordered_categories: [],
                filter_keys: [],
                ordered_product_tokens: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISearchMakerProductsRequest.ISortingHint || (ISearchMakerProductsRequest.ISortingHint = {}));
    (function(IRankingBoost) {
        IRankingBoost.build = function(partial) {
            return _object_spread({
                referrer_filters: [],
                referrer_products: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISearchMakerProductsRequest.IRankingBoost || (ISearchMakerProductsRequest.IRankingBoost = {}));
    (function(SortBy) {
        /**
     * Last modified first.
     */ SortBy["LAST_MODIFIED"] = "LAST_MODIFIED";
        /**
     * Sort alphabetically.
     */ SortBy["A_TO_Z"] = "A_TO_Z";
        SortBy["Z_TO_A"] = "Z_TO_A";
        SortBy["FEATURED"] = "FEATURED";
        /**
     * Active products first (with FEATURED as tie-breaker).
     */ SortBy["ACTIVE_FIRST"] = "ACTIVE_FIRST";
        /**
     * Discontinued + Backordered products first (with FEATURED as tie-breaker).
     */ SortBy["INACTIVE_FIRST"] = "INACTIVE_FIRST";
        /**
     * Sort by Wholesale price.
     */ SortBy["WHOLESALE_PRICE_DESC"] = "WHOLESALE_PRICE_DESC";
        SortBy["WHOLESALE_PRICE_ASC"] = "WHOLESALE_PRICE_ASC";
        SortBy["NEWEST"] = "NEWEST";
        /**
     * Sort by the category order specified in SortingHint.
     * Products in unspecified categories will be put to the end of the list.
     */ SortBy["CATEGORIES"] = "CATEGORIES";
        /**
     * Boost the products that match the Elastic Search query in SortingHint.
     */ SortBy["BOOST_PRODUCTS_QUERY"] = "BOOST_PRODUCTS_QUERY";
        /**
     * Boost new products (usually when brand is known)
     */ SortBy["BOOST_NEW_PRODUCTS_QUERY"] = "BOOST_NEW_PRODUCTS_QUERY";
        /**
     * Sort by products that match the most filter keys first. Ties are broken by FEATURED ranking.
     * Intended to boost maker products ranking based of filters used in category navigation.
     */ SortBy["FILTER_KEYS"] = "FILTER_KEYS";
        /**
     * Sort by Retail price.
     */ SortBy["RETAIL_PRICE_DESC"] = "RETAIL_PRICE_DESC";
        SortBy["RETAIL_PRICE_ASC"] = "RETAIL_PRICE_ASC";
        /**
     * Sort by most ordered products.
     */ SortBy["MOST_ORDERED_DESC"] = "MOST_ORDERED_DESC";
        /**
     * Sort by most recently ordered products.
     */ SortBy["MOST_RECENT_ORDERED_DESC"] = "MOST_RECENT_ORDERED_DESC";
        /**
     * Sort by the brand's best selling products.
     * @deprecated
     */ SortBy["BESTSELLERS"] = "BESTSELLERS";
        /**
     * Use brand sourced ordering.
     */ SortBy["BRAND_ARRANGEMENT"] = "BRAND_ARRANGEMENT";
    })(ISearchMakerProductsRequest.SortBy || (ISearchMakerProductsRequest.SortBy = {}));
    (function(ClientSize) {
        ClientSize["CLIENT_SIZE_UNKNOWN"] = "CLIENT_SIZE_UNKNOWN";
        ClientSize["DESKTOP"] = "DESKTOP";
        ClientSize["MOBILE"] = "MOBILE";
    })(ISearchMakerProductsRequest.ClientSize || (ISearchMakerProductsRequest.ClientSize = {}));
    ISearchMakerProductsRequest.build = function(partial) {
        return _object_spread({
            filter_keys: [],
            range_filters: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ISearchMakerProductsRequest || (ISearchMakerProductsRequest = {}));
export var ISearchMakerProductsRequest;
